// extracted by mini-css-extract-plugin
export default {"bottomAreaGrid":"bottomArea_bottomAreaGrid__POAtr","bottomAreaGridChild":"bottomArea_bottomAreaGridChild__R0Cww","orangeText":"bottomArea_orangeText__b+J80"};